import axios from 'axios';
import { getBackendUrl, safeGetSessionStorage } from '../utils/backendUtils';

// 創建axios實例
const http = axios.create({
  baseURL: getBackendUrl(),
  timeout: 10000, // 請求超時時間
  headers: {
    'Content-Type': 'application/json'
  }
});

// 請求攔截器
http.interceptors.request.use(
  config => {
    // 從sessionStorage獲取token（支援多帳號同時登入）
    const token = safeGetSessionStorage('admin_token');
    if (token) {
      // 為請求添加Authorization頭
      config.headers['Authorization'] = `Bearer ${token}`;
    }
    return config;
  },
  error => {
    return Promise.reject(error);
  }
);

// 響應攔截器
http.interceptors.response.use(
  response => {
    // 直接返回數據部分
    return response;
  },
  error => {
    // 處理 HTTP 錯誤
    if (error.response) {
      const { status } = error.response;

      // 處理401未授權錯誤（登入過期）
      if (status === 401) {
        // 清除當前分頁的token並重定向到登入頁（支援多帳號同時登入）
        sessionStorage.removeItem('admin_token');
        sessionStorage.removeItem('admin_user');
        window.location.href = '/login';
      }

      // 顯示錯誤訊息
      console.error(`錯誤狀態碼: ${status}`, error.response.data);
    } else if (error.request) {
      // 請求發出但沒有收到響應
      console.error('網絡錯誤，請檢查您的網絡連接', error.request);
    } else {
      // 請求配置有誤
      console.error('請求錯誤:', error.message);
    }

    return Promise.reject(error);
  }
);

export default http;